import PresentationViewer from './PresentationViewer'

// המצגת משתמשת בבורר שנה/סמסטר המשותף של הדשבורד (DashboardContext) — ר' PresentationViewer
const ReadingProfilePresentationCard = () => <PresentationViewer />

export default ReadingProfilePresentationCard
